module.exports = __webpack_public_path__ + "img/credit_card.09529f38.svg";